/* eslint-disable sort-imports */ // <--- need to keep this specific order
import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// Route imports
import AccountabilityAssistantRoutes from "./routes/accountability-assistant";
import AceRoutes from "./routes/ace";
import AuthRoutes from "./routes/auth";
import BlacklistRoutes from "./routes/blacklist";
import ContentPageRoutes from "./routes/content-page";
import FacilityRoutes from "./routes/facility";
import FacilityFeatureRoutes from "./routes/feature";
import GenericRoutes from "./routes/generic";
import GiftCardsRoutes from "./routes/gift-cards";
import GlobalSettingRoutes from "./routes/global-setting";
import HelpCenterRoutes from "./routes/help-center";
import LandingPageRoutes from "./routes/landing-page";
import LocationRoutes from "./routes/location";
import ManagerTabletRoutes from "./routes/manager-tablet";
import NavigationRoutes from "./routes/navigation";
import RedirectRoutes from "./routes/redirect";
import ReviewsApprovalRoutes from "./routes/reviews-approval";
import RobotRoutes from "./routes/robots";
import StaticPageRoutes from "./routes/static-page";
import SurveysRoutes from "./routes/surveys";
import TPPClaimsRoutes from "./routes/tpp-claims";
import UserRoutes from "./routes/user";

Vue.use(Router);

export function ifNotAuthenticated(to, from, next) {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }

  next("/");
}

export function ifAuthenticated(to, from, next) {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }

  next("/login");
}

export const routes = [
  ...AccountabilityAssistantRoutes,
  ...AceRoutes,
  ...AuthRoutes,
  ...BlacklistRoutes,
  ...ContentPageRoutes,
  ...FacilityRoutes,
  ...FacilityFeatureRoutes,
  ...GenericRoutes,
  ...GiftCardsRoutes,
  ...GlobalSettingRoutes,
  ...HelpCenterRoutes,
  ...LandingPageRoutes,
  ...LocationRoutes,
  ...ManagerTabletRoutes,
  ...NavigationRoutes,
  ...RedirectRoutes,
  ...ReviewsApprovalRoutes,
  ...RobotRoutes,
  ...StaticPageRoutes,
  ...SurveysRoutes,
  ...TPPClaimsRoutes,
  ...UserRoutes
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
